import React from 'react';
import IncreaseDecreaseInputButton from '../../../../../../components/Purchase/IncreaseDecreaseInputButton';
import { RadioButton } from '@gerdau/hefesto/RadioButton';
import {
  MockupRowContainer,
  MockupDataInputContainer,
  IncreaseDecreaseContainer,
  SecondaryInputContainer,
  OptionsContainer,
  Description
} from '../styles';
import { KeyValueItem } from '@gerdau/hefesto-mais-web';

interface NumberOfPavementsProps {
  pavementsAboveGround: number;
  setPavementsAboveGround: (pavementsAboveGround: number) => void;
  pavementsBelowGround: number;
  setPavementsBelowGround: (pavementsBelowGround: number) => void;
  isEdit: boolean;
  isLoading: boolean;
}

const NumberOfPavements: React.FC<NumberOfPavementsProps> = ({
  pavementsAboveGround,
  setPavementsAboveGround,
  pavementsBelowGround,
  setPavementsBelowGround,
  isEdit,
  isLoading
}) => {
  const onIncreaseAboveGround = () => {
    setPavementsAboveGround(pavementsAboveGround + 1);
  };

  const onDecreaseAboveGround = () => {
    setPavementsAboveGround(pavementsAboveGround - 1);
  };

  const onIncreaseBelowGround = () => {
    setPavementsBelowGround(pavementsBelowGround + 1);
  };

  const onDecreaseBelowGround = () => {
    setPavementsBelowGround(pavementsBelowGround - 1);
  };

  return (
    <>
      <MockupRowContainer>
        <Description>
          {'Número de pavimentos acima do nível terreo:'}
        </Description>
        <IncreaseDecreaseContainer>
          <IncreaseDecreaseInputButton
            value={pavementsAboveGround.toString()}
            disabled={!!isLoading}
            readOnly={isEdit}
            onChange={(value) => {
              if (Number(value) > 1) setPavementsAboveGround(Number(value));
            }}
            onIncreaseClick={onIncreaseAboveGround}
            onDecreaseClick={onDecreaseAboveGround}
            minValue={1}
            errorMessage={''}
          />
        </IncreaseDecreaseContainer>
      </MockupRowContainer>

      <MockupRowContainer>
        <MockupDataInputContainer>
          <KeyValueItem title="Existem pavimentos abaixo do nível térreo? ">
            {''}
          </KeyValueItem>
          <OptionsContainer>
            <RadioButton
              checked={pavementsBelowGround > 0}
              disabled={isEdit || !!isLoading}
              value={'1'}
              label={'Sim'}
              id={'yesPavementsBelowGroundRadio'}
              name={'yesPavementsBelowGroundRadio'}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPavementsBelowGround(Number(e.target.value));
              }}
            ></RadioButton>
            <RadioButton
              checked={pavementsBelowGround === 0}
              disabled={isEdit || !!isLoading}
              value={'0'}
              label={'Não'}
              id={'noPavementsBelowGroundRadio'}
              name={'noPavementsBelowGroundRadio'}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setPavementsBelowGround(Number(e.target.value));
              }}
            ></RadioButton>
          </OptionsContainer>

          {pavementsBelowGround > 0 && (
            <SecondaryInputContainer>
              <Description>Insira a quantidade:</Description>
              <IncreaseDecreaseContainer>
                <IncreaseDecreaseInputButton
                  value={pavementsBelowGround.toString()}
                  onChange={(value) => setPavementsBelowGround(Number(value))}
                  onIncreaseClick={onIncreaseBelowGround}
                  onDecreaseClick={onDecreaseBelowGround}
                  readOnly={isEdit || !!isLoading}
                  errorMessage={''}
                />
              </IncreaseDecreaseContainer>
            </SecondaryInputContainer>
          )}
        </MockupDataInputContainer>
      </MockupRowContainer>
    </>
  );
};

export default NumberOfPavements;
